const emitEvents = {
    confirmationCodeComplete: 'confirmationCodeComplete',
};

export {emitEvents};
